import { Box, Button, Grid, TextField } from '@mui/material';
import React from 'react';
import { TextInput } from 'components';

const EarnItemForm = ({ earnItem, isEditing, handleChange }) => (
	<Grid container spacing={1}>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={earnItem.name}
				label="Name"
				name="name"
				placeholder="Name"
				handleChange={handleChange}
			/>
		</Grid>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={earnItem.xp}
				label="XP"
				name="xp"
				placeholder="XP"
				type="number"
				handleChange={handleChange}
			/>
		</Grid>
		<Grid item xs={12} sm={12}>
			<TextInput
				value={earnItem.coins}
				label="Coins"
				name="coins"
				placeholder="Coins"
				handleChange={handleChange}
				type="number"
			/>
			<TextInput
				value={earnItem.item}
				label="Type"
				name="item"
				placeholder="Type"
				handleChange={handleChange}
				type="text"
				disabled={true}
			/>
		</Grid>
	</Grid>
);

export default EarnItemForm;
